(function($) {
	window.rw.productCardMain = ()=> {
		const $header = $('[ref="the-header"]');
		const $main = $('#main');

		const render = ()=>{
			window.removeEventListener('resize', window.rw.setHeaderDynamicPadding);
			window.removeEventListener('scroll', window.rw.theHeader.scrollHandler);
			$header.addClass('page-header--plain');
			$main.addClass('--plain');
			$main.removeAttr('style');
		};

		render();

		return {render};
	};

	document.addEventListener('DOMContentLoaded', ()=>{});
// eslint-disable-next-line no-undef
})(jQuery);
